import { FIELDS } from '../constants'
import { Field, FieldProps } from '../field'
import { email, required } from '../validators'

const { id, label } = FIELDS.email

export interface EmailField {
  email?: string
}

export const Email = (props: Partial<FieldProps>) => (
  <Field
    data-private
    id={id}
    label={label}
    type="email"
    validators={{ ...required, ...email }}
    {...props}
  />
)
